import { render, staticRenderFns } from "./itemGroup.vue?vue&type=template&id=1384bb39"
import script from "./itemGroup.vue?vue&type=script&lang=js"
export * from "./itemGroup.vue?vue&type=script&lang=js"
import style0 from "./itemGroup.vue?vue&type=style&index=0&id=1384bb39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports